<template>
  <SlideSidebarContainer>
    <template v-slot:title>
      <span>lista de favoritos</span>
    </template>

    <template v-slot:subtitle>
      Seus cursos marcados como favoritos
    </template>

    <UserPlaylistCourses />
  </SlideSidebarContainer>
</template>

<script>
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
  import UserPlaylistCourses from '@/components/playlist/UserPlaylistCourses'

  export default {
    components: {
      SlideSidebarContainer,
      UserPlaylistCourses,
    }
  }
</script>